module.exports = __webpack_public_path__ + "img/bottomback.87866f65.svg";